module.exports = __webpack_public_path__ + "img/DO.27aeb85c.svg";